module.exports = __webpack_public_path__ + "media/images/pic/hero/sign-73d61a178291a45cb135e6f7a260499f.png";